import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {Chart} from 'angular-highcharts';
import * as DemoAction from '../../../demo/store/demo.actions';
import {ChartService} from '../../chart.service';
import {ProfileService} from '../../profile.service';

@Component({
    selector: 'app-profile-media-engage-pro',
    templateUrl: './profile-media-engage-pro.component.html',
    styleUrls: ['./profile-media-engage-pro.component.scss'],
    standalone: false
})
export class ProfileMediaEngageProComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  chartsFollowerEngage: Chart[];
  profileSubscription: Subscription;
  engagementStat: any[];

  constructor(
    private store: Store<fromApp.AppState>,
    private profileService: ProfileService
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');

    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        if (state.followerEngage !== null) {
          this.chartsFollowerEngage = [];
          this.chartsFollowerEngage.push(
            ChartService.getEngageByDayChart(state.followerEngage)
          );
          const engagementStat = this.profileService.getProfileEngagementStat();

          for (const i in engagementStat) {
            const e = engagementStat[i];
            if (e.range.from < state.followerEngage.follower_count && e.range.to > state.followerEngage.follower_count) {
              engagementStat[i]['profile'] = {
                engage: state.followerEngage.engage_count
              };
            }
          }
          this.engagementStat = engagementStat;
        }

      }
    );
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

}
